if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        // TD CHANGE - Validate size at click in the capture phase so it runs before cart apps (e.g. UpCart)
        // that intercept the add and would otherwise swallow our "select a size" feedback.
        this.form.addEventListener('click', this.onAddToCartClick.bind(this), true);
        // END TD CHANGE
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // TD CHANGE - Block the add and show the size hint when no variant is selected.
      // Capture-phase click handler so it beats third-party cart apps that hijack the button.
      onAddToCartClick(evt) {
        const addButton = evt.target.closest('[name="add"]');
        if (!addButton || !this.form.contains(addButton)) return;

        const variantInput = this.form.querySelector('[name=id]');
        if (variantInput && !variantInput.value) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          this.toggleSizeHint(true);
        } else {
          this.toggleSizeHint(false);
        }
      }

      toggleSizeHint(show) {
        const sizeHint = (this.closest('.shopify-section') || document).querySelector('.td-size-select-hint');
        if (sizeHint) sizeHint.classList.toggle('td-size-select-hint--visible', show);
      }
      // END TD CHANGE

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // TD CHANGE - Fallback guard (e.g. keyboard submit) when no variant is selected
        const variantInput = this.form.querySelector('[name=id]');
        if (variantInput && !variantInput.value) {
          this.toggleSizeHint(true);
          return;
        }
        this.toggleSizeHint(false);
        // END TD CHANGE

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            if(this.cart) {
              const renderCart = new Event('cart:updated:corso'); 
              this.cart.dispatchEvent(renderCart);
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
